export default __webpack_public_path__ + "static/media/OrbitLogo_Purple.7144781a.png";